module.exports = __webpack_public_path__ + "img/6.70036865.png";